import { graphql,useStaticQuery } from 'gatsby';
import lang from 'lang/pl';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({ title, description, keywords, contentType, image, alt, url, locale, lang, meta }) {
	const { site } = useStaticQuery(
		graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    author
                }
            }
        }
		`
	);

	const seoDescription = description || site.siteMetadata.description;
	const seoTitle = title || site.siteMetadata.title;

	return (
		<Helmet
			defaultTitle='Faktoring online, pełny, niepełny, odwrotny, dla firm'
			htmlAttributes={{ lang }}
			meta={[
				{ property: 'og:site_name', content: 'Smart Faktor S.A.' },
				{ property: 'og:type', content: contentType },
				{ property: 'og:title', content: seoTitle },
				{ property: 'og:description', content: seoDescription },
				{ property: 'og:image', content: image },
				{ property: 'og:image:alt', content: alt },
				{ property: 'og:locale', content: locale },
				{ name: 'keywords', content: keywords },
				{ name: 'description', content: seoDescription },
				{ name: 'image', content: image },
				{ name: 'twitter:card', content: 'summary' },
				{ name: 'twitter:site', content: '@Smart_Faktor' },
				{ name: 'twitter:title', content: seoTitle },
				{ name: 'twitter:description', content: seoDescription },
				{ name: 'twitter:image', content: image },
				{ name: 'twitter:image:alt', content: alt },
				{ name: 'twitter:creator', content: site.siteMetadata.author }
			].concat(meta)}
		>
			<title>{seoTitle}</title>
		</Helmet>
	);
}

SEO.defaultProps = {
	contentType: 'website', // Use article for articles and website for the rest of your pages.
	title: lang.translations.app.title,
	description: lang.translations.app.description,
	keywords: lang.translations.app.keywords,
	url: null, // basically tells the FB scraper "ignore anything on this page, and scrape this url instead"
	image: `${process.env.GATSBY_API_SEO_URL}/files/social-main.png`,
	alt: lang.translations.app.name,
	lang: 'pl-PL',
	locale: 'pl_PL',
	meta: []
};

SEO.propTypes = {
	title: PropTypes.string,
	keywords: PropTypes.string,
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
};

export default SEO;
